<ng-template [ngIf]="drawerOpened">
  <div class="drawer-toggle" (click)="toggleDrawer()">
    <img src="/assets/images/drawer-close.png" aria-label="Close Drawer">
  </div>
  <ng-content select=".show-opened"></ng-content>
</ng-template>

<ng-template [ngIf]="!drawerOpened">
  <div class="drawer-toggle" (click)="toggleDrawer()">
    <img src="/assets/images/drawer-open.png" aria-label="Open Drawer">
  </div>
  <ng-content select=".show-closed"></ng-content>
</ng-template>
